/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Hero_SubtitleInputs */

const en_contact_hero_subtitle = /** @type {(inputs: Contact_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get in touch with the right people at Listening. We're here to help!`)
};

const es_contact_hero_subtitle = /** @type {(inputs: Contact_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponte en contacto con las personas adecuadas en Listening. ¡Estamos aquí para ayudarte!`)
};

/**
* | output |
* | --- |
* | "Get in touch with the right people at Listening. We're here to help!" |
*
* @param {Contact_Hero_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const contact_hero_subtitle = /** @type {((inputs?: Contact_Hero_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Hero_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_hero_subtitle(inputs)
	return en_contact_hero_subtitle(inputs)
});